import React from "react";

import Button from '@material-ui/core/Button';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

export const BackButton = (props) => {
	return <Button color="secondary" style={{ margin: "2vh", minWidth: "10vw" }} startIcon={<ArrowBackIosIcon />} {...props}>{!!props.textbutton ? props.textbutton : 'Precedente'}</Button>;
}